var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "M12.119 13.53a1 1 0 0 0-.24 0 3.28 3.28 0 1 1 .24 0ZM18.738 20.13a9.93 9.93 0 0 1-6.74 2.62 9.93 9.93 0 0 1-6.74-2.62 3.68 3.68 0 0 1 1.77-2.58 9.73 9.73 0 0 1 9.94 0 3.68 3.68 0 0 1 1.77 2.58Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "M22 12.75a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z"
})));
export { SvgUsers as ReactComponent };
export default __webpack_public_path__ + "57e953339145d13b610017b2f2cc2770.svg";